import { createAction } from "redux-act";
export var loginRequest = createAction("[[async]] login request");
export var loginRequestSuccess = createAction("login request success");
export var registerRequest = createAction("[[async]] register request");
export var registerRequestSuccess = createAction("register request success");
export var registerRequestFail = createAction("register request fail");
export var verifyCodeRequest = createAction("[[async]] verify code request");
export var verifyCodeRequestSuccess = createAction("verify code request success");
export var verifyCodeRequestFail = createAction("verify code request fail");
export var resendCodeRequest = createAction("[[async]] resned code request");
export var verifyPhoneNumberRequest = createAction("[[async]] verify phone number request");
export var verifyPhoneNumberResponse = createAction("verify phone number response");
export var verifyEmailRequest = createAction("[[async]] verify email request");
export var verifyEmailResponse = createAction("verify email response");



//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/ducks/actions.ts
// module id = 145
// module chunks = 0